import { apiRequest } from "./httpClient";

export async function getCredentials(username, token) {
    return apiRequest("api/users/get-credentials", { token, body: { username } });
}

export async function changeCredentials(username, token, newFullName, newMail, newUsername, newDescription, currentPassword, newPassword) {
    return apiRequest("api/users/change-credentials", {
        token,
        body: { username, newFullName, newMail, newUsername, newDescription, currentPassword, newPassword },
    });
}

export async function deletePP(username, token) {
    return apiRequest("api/users/delete-image", { token, body: { username } });
}